import isNumber from 'lodash/isNumber';
import map from 'lodash/map';
import reject from 'lodash/reject';
import sumBy from 'lodash/sumBy';

import { formatNumberToCurrency } from './common';

import { PRICE_TYPES } from 'constants/session-form';

export const getTotalCostRange = (minTotalCost, maxTotalCost, formatCost = formatNumberToCurrency) => {
  // Free packages show their zero cost; sessions can't be priced at zero
  if (minTotalCost === 0 && maxTotalCost === 0) return formatCost(0);

  if (minTotalCost > 0) {
    let costRange = formatCost(minTotalCost);

    if (minTotalCost < maxTotalCost) {
      costRange = costRange.concat(` - ${formatCost(maxTotalCost)}`);
    }

    return costRange;
  } else return '';
};

export const getTotalCostWithDiscount = ({ discountPercentage = 0, originalCost = 0 }) => {
  const profitRate =
    isNumber(discountPercentage) && discountPercentage >= 0 && discountPercentage <= 100
      ? (100 - discountPercentage) / 100
      : 1;
  return parseFloat(originalCost) * profitRate;
};

export const getSessionCostBounds = (session = {}) => {
  const { audio, audioPremiumFee, videoconference, videoPremiumFee, inPersonMeeting, inPersonPremiumFee, priceType } =
    session;

  const subtotalCost = parseFloat(session.subtotalCost);
  const premiumFees = reject(
    [audio && audioPremiumFee, videoconference && videoPremiumFee, inPersonMeeting && inPersonPremiumFee],
    (v) => [false, null, undefined, '', NaN].includes(v),
  );
  const minPremiumFee = priceType === PRICE_TYPES.custom ? Math.min(...premiumFees) : 0;
  const maxPremiumFee = priceType === PRICE_TYPES.custom ? Math.max(...premiumFees) : 0;

  return { minTotalCost: subtotalCost + minPremiumFee, maxTotalCost: subtotalCost + maxPremiumFee };
};

export const getPackCostBounds = (sessions = [], discountPercentage = 0) => {
  const sessionBounds = map(sessions, getSessionCostBounds);

  return {
    minTotalCost: getTotalCostWithDiscount({ originalCost: sumBy(sessionBounds, 'minTotalCost'), discountPercentage }),
    maxTotalCost: getTotalCostWithDiscount({ originalCost: sumBy(sessionBounds, 'maxTotalCost'), discountPercentage }),
  };
};

export const getPackageCostBounds = (pack = {}) => {
  const { priceType, packageCost, callTypes, discountPercentage } = pack;

  return priceType === PRICE_TYPES.custom
    ? getPackCostBounds(callTypes, discountPercentage)
    : { minTotalCost: packageCost, maxTotalCost: packageCost };
};
